import { ReactNode, createContext, useContext } from 'react';

type AnalyticsContextType = {
  trackAction: (actionType: string, details?: any) => Promise<void>;
};

const AnalyticsContext = createContext<AnalyticsContextType>({
  trackAction: async () => {},
});

export const useAnalytics = () => useContext(AnalyticsContext);

export const AnalyticsProvider = ({ children }: { children: ReactNode }) => {
  // No-op analytics provider — real analytics API not yet available
  const trackAction = async (_actionType: string, _details?: any) => {
    // Will be wired to backend analytics API when available
  };

  return (
    <AnalyticsContext.Provider value={{ trackAction }}>
      {children}
    </AnalyticsContext.Provider>
  );
};
